import { render, staticRenderFns } from "./PageNotAllowedWithoutContainer.vue?vue&type=template&id=a2247506&"
import script from "./PageNotAllowedWithoutContainer.vue?vue&type=script&lang=js&"
export * from "./PageNotAllowedWithoutContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports